export default __webpack_public_path__ + "static/TekRevol-e7ee62f862520bafdbfeb9dcb1245ea4.webp";